var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('a',{attrs:{"href":_vm.link}},[(_vm.app)?_c('img',{attrs:{"src":_vm.app.photo,"alt":_vm.app.name,"height":_vm.height}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }